import { useEffect, useRef } from 'react';

export default function MouthpieceCta() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.fade-up, .scale-in').forEach((el) => {
              el.classList.add('visible');
            });
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="floating-cta-hide" ref={sectionRef} className="py-20" style={{ backgroundColor: '#3E5F8F' }}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="scale-in">
          <a
            href="https://reservation.stransa.co.jp/8878b04a60c23f1ce5b3268e265263cb"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-white hover:bg-gray-50 px-10 py-5 rounded-lg text-xl font-bold transition-all transform hover:scale-105 shadow-xl mb-8 whitespace-nowrap cursor-pointer"
            style={{ color: '#3E5F8F' }}
          >
            無料診断を予約する(レポート作成)
            <i className="ri-arrow-right-line" />
          </a>
        </div>
        <div className="text-white text-sm space-y-1 fade-up">
          <p>※ 初回相談・診査・あなた専用 矯正プラン比較レポートの作成・ご説明まですべて無料です</p>
          <p>※ 後日45分枠は初回来院時に予約をお取りします(来院・オンライン可)</p>
          <p>※ その場で治療を決める必要はありません</p>
          <p>※ モユクに買い物に来るついでで大丈夫です</p>
        </div>
      </div>
    </section>
  );
}